import React from 'react';

const Logo = ({ variant = "dark", className = "" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      {variant === "dark" ? (
        <img 
          src="https://customer-assets.emergentagent.com/job_mirror-web-11/artifacts/dry2e3zp_Guag%20LOGO%20%2B%20tm.png"
          alt="GUAG"
          className="h-8 w-auto"
        />
      ) : (
        <img 
          src="https://customer-assets.emergentagent.com/job_mirror-web-11/artifacts/dry2e3zp_Guag%20LOGO%20%2B%20tm.png"
          alt="GUAG"
          className="h-8 w-auto brightness-0 invert"
        />
      )}
    </div>
  );
};

export default Logo;
